export const TopupReducer = (state: any, action: any) => {
  switch (action.type) {
    case "show_topup":
      let showTopup = state.showTopup;
      document.body.classList[!showTopup ? "add" : "remove"](
        "h-screen",
        "overflow-hidden"
      );
      return { ...state, showTopup: !showTopup };
    case "show_filter":
      let showFilter = state.showFilter;
      document.body.classList[!showFilter ? "add" : "remove"](
        "h-screen",
        "overflow-hidden"
      );
      return { ...state, showFilter: !showFilter };
    case "show_cancel":
      let cancel = action.payload;
      document.body.classList[cancel.status ? "add" : "remove"](
        "h-screen",
        "overflow-hidden"
      );
      return { ...state, showCancel: cancel };
    case "handle_chip":
      let new_chip = action.payload;
      return { ...state, chip: new_chip };
  }
};
